import angular from 'angular';
import footerCoreComponent from './footer-core.component';
import FooterCoreService from './footer-core.service';
import footerCoreConfig from './footer-core.config';

let footerCoreModule = angular.module('app.footerCore', [])
    .component('footerCore', footerCoreComponent)
    .service('FooterCoreService', FooterCoreService)
    .config(footerCoreConfig);

export default footerCoreModule;



// WEBPACK FOOTER //
// ./www/components/footer-core/footer-core.js